import { StyleFactory } from '../styling';
import { getBarbColorExpression, getBarbsExpression } from './common';

export const turbulenceAdvisories: StyleFactory = (baseId) => {
    return [
        {
            type: 'fill',
            pickable: true,
            source: baseId,
            id: baseId + '-fill',
            paint: {
                'fill-color': '#00dc00',
                'fill-opacity': ['global-state', 'polygon-transparency']
            }
        },
        {
            type: 'line',
            source: baseId,
            id: baseId + '-fill-outline',
            paint: {
                'line-width': 2,
                'line-color': '#00dc00'
            }
        }
    ];
};

export const tapsLayers: StyleFactory = (baseId, settings) => {
    return [
        {
            type: 'symbol',
            pickable: true,
            source: baseId,
            id: baseId + '-symbol',
            layout: {
                'icon-allow-overlap': true,
                'icon-pitch-alignment': 'map',
                'icon-rotation-alignment': 'map',
                // prettier-ignore
                'icon-image': ['image', 
                    ['at', ['get', 'iconColor'], ['literal', ['taps-0', 'taps-1', 'taps-2', 'taps-3', 'taps-4', 'taps-5', 'taps-6']]]
                ],
                'icon-size': 0.4
            }
        },
        {
            type: 'symbol',
            source: baseId,
            filter: ['!=', ['get', 'wind'], ['literal', null]],
            id: baseId + '-barbs',
            layout: {
                'icon-allow-overlap': true,
                'icon-rotate': ['get', 'dir'],
                'icon-pitch-alignment': 'map',
                'icon-rotation-alignment': 'map',
                'icon-anchor': 'bottom',
                'icon-size': ['global-state', 'wind-barbs-size'],
                'icon-image': getBarbsExpression(['get', 'wind'])
            },
            paint: {
                'icon-color': getBarbColorExpression(settings, ['get', 'wind'])
            }
        }
    ];
};
